export default function () {
    const $quizModule = $('.module-quiz');

    if (!$quizModule.length) {
        return;
    }

    // get all the checked controls of the current question,
    // iterate over result and sum up values as points
    const getValueOfCurrentControl = ($quizCurrent) => {
        let answerVal = 0;

        // iterate over result items,
        // since selection might contain more than one selected item - checkboxes
        $quizCurrent.find('.custom-control-input:checked').each((i, e) => {
            answerVal += parseInt($(e).val(), 10);
        });

        return answerVal;
    };

    const $quizTypeData = $quizModule.find('.quiz-type').data('quiztype');
    const $quizTypeMode = $quizModule.find('.quiz-type').data('quizmode');
    const $questionContainer = $quizModule.find('.quiz-question-container');
    const $answerControls = $questionContainer.find('.custom-control-input');
    const $quizButtonNext = $questionContainer.find('.quiz-button.--next');
    const $quizButtonPrev = $questionContainer.find('.quiz-button.--previous');
    const $quizButtonResult = $questionContainer.find('.quiz-button.--result');
    const $quizButtonRepeat = $quizModule.find('.quiz-button.--repeat');
    const $answersArray = [];

    // event click on radios and checkboxes
    $answerControls.on('click', (e) => {
        const $this = $(e.target);
        const $quizQuestion = $this.closest('.quiz-question-container');
        const $targetNext = $quizQuestion.find('.quiz-button.--next');
        const $targetPrev = $quizQuestion.find('.quiz-button.--result');

        $targetNext.removeAttr('disabled');
        $targetPrev.removeAttr('disabled');

        if ($quizTypeMode === 'withanswers') {
            $quizQuestion.find('label').css('color', 'initial');
            $quizQuestion.find('.quiz-answer').fadeIn();
            const $answerLabel = $this.closest('label');
            if ($this.attr('value') > 0) {
                $answerLabel.css('color', 'green');
            } else {
                $answerLabel.css('color', 'red');
            }
        }
    });

    // event click on previous button
    $quizButtonPrev.on('click', (e) => {
        const $this = $(e.target);
        const $quizCurrent = $this.closest('.quiz-question-container');
        const $quizCurrentData = $quizCurrent.data('quiz');
        const $quizPrev = $quizCurrent.prev();
        const $answerVal = parseInt($quizCurrent.find('.custom-control-input:checked').val(), 10);

        $quizCurrent.hide();
        $quizPrev.show();
        $answersArray[$quizCurrentData] = $answerVal;
    });

    // event click on next button
    $quizButtonNext.on('click', (e) => {
        const $this = $(e.target);
        const $quizCurrent = $this.closest('.quiz-question-container');
        const $quizCurrentData = $quizCurrent.data('quiz');
        const $quizNext = $quizCurrent.next();
        const $answerVal = getValueOfCurrentControl($quizCurrent);

        $quizCurrent.hide();
        $quizNext.show();
        $answersArray[$quizCurrentData] = $answerVal;
    });

    // event click on result button
    $quizButtonResult.on('click', (e) => {
        const $this = $(e.target);
        const $quizCurrent = $this.closest('.quiz-question-container');
        const $quizCurrentData = $quizCurrent.data('quiz');
        const $answerVal = getValueOfCurrentControl($quizCurrent);
        const $quizResultContainer = $quizModule.find('.quiz-result-container');
        const $quizTotal = $quizResultContainer.find('.quiz-total');
        const $quizResult = $quizResultContainer.find('.quiz-result');

        $quizCurrent.hide();

        $answersArray[$quizCurrentData] = $answerVal;

        // sum of the answer values
        const answersArraySum = (arr) => arr.reduce((a, b) => a + b, 0);
        const answerSum = answersArraySum($answersArray);

        if ($quizTypeMode === 'generic' || $quizTypeMode === 'withanswers') {
            $quizResultContainer.show();
            $quizTotal.text(answerSum);
            let $quizResultContainerAnswer = null;

            $($quizResult.get().reverse()).each((i, f) => {
                const $item = $(f);
                const $value = $item.data('result');

                if ($quizResultContainerAnswer === null || parseInt(answerSum, 10) <= parseInt($value, 10)) {
                    $quizResultContainerAnswer = $item;

                    return true;
                }

                return false;
            });

            $quizResultContainerAnswer.show();

            return;
        }

        if ($quizTypeData === 'alkohol') {
            // change total value
            $quizTotal.text(answerSum);

            $quizResultContainer.show();
            $quizResult.show();
        }

        if ($quizTypeData === 'depression') {
            $quizResultContainer.show();

            if (answerSum < 4) {
                $('.quiz-result[data-result="0"]').show();
            } else if (answerSum < 6) {
                $('.quiz-result[data-result="4"]').show();
            } else if (answerSum < 8) {
                $('.quiz-result[data-result="6"]').show();
            } else if (answerSum < 99) {
                $('.quiz-result[data-result="8"]').show();
            } else {
                $('.quiz-result[data-result="99"]').show();
            }
        }
    });

    // Undo everything
    $quizButtonRepeat.on('click', (e) => {
        const $this = $(e.target);
        const $quizCurrent = $this.closest('.module-quiz');
        const $currentContainer = $quizCurrent.find('.quiz-question-container');
        $quizCurrent.find('.quiz-result-container').hide();
        $quizCurrent.find('.quiz-result').hide();
        $quizCurrent.find('.quiz-question-container').hide();
        $quizCurrent.find('.custom-control-input').prop('checked', false);
        $quizCurrent.find('.quiz-button.--next').prop('disabled', true);
        $quizCurrent.find('.quiz-button.--result').prop('disabled', true);
        $currentContainer.first().show();
    });
}
